export default {
  getTooltipClass({ theme = 'light', arrowPosition = 'top', header = '', desc = '', supportive = false } = {}) {
   return [
      'p-tooltip',                   // base class
      `p-tooltip--${theme}`,         // theme (light | dark)
      `p-tooltip--${arrowPosition}`, // arrow position (top | bottom | left | right)
      supportive ? 'p-tooltip--supportivetext' : '' 
    ].join(' ');
  },

  formatTooltipValue({ value  }) {
    if(!value) {
      return;
    }
    return value
     .split("\n")
     .map(line =>`<p>${line}</p>`
    ).join('');
  }

};

